import { Box } from '@mui/material';
import { decode } from 'js-base64';
import { memo, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { BaseImage } from '~/components/common';

const Preview = () => {
  const { id } = useParams();
  const [fileUrl, setFileUrl] = useState<string>();

  useEffect(() => {
    if (id) {
      try {
        setFileUrl(decode(id));
      } catch (e) {
        console.error('File not found');
      }
    }
  }, [id]);

  if (!fileUrl) return 'File Not Found';

  return (
    <Box className='bg-black flex justify-center w-full h-full p-[10px]'>
      <BaseImage src={fileUrl} />
    </Box>
  );
};

export default memo(Preview);
